import { sectorService } from "../services/sectors";
import { companyService } from "../services/companies";
import { cropService } from "../services/crops";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { clearAllTables } from "../utils/ui_utils";
import { hideMenu } from "../shared.js";

export class SectorController {
  constructor() {
    this.type = "sector";
    this.sectorNav = document.querySelector(".sector_nav");
    this.sectorTableWindow = document.querySelector(".sector_table_window");
    this.updateWindow = document.querySelector(".update-sector-window");
    this.form = document.querySelector(".upload-sector");
    this.btnModal = document.querySelector(".table_modal-sector");
    this.table = null; // Tabulator instance
  }

  async init(currBtn, currAcc) {
    this.updateUI(currBtn);
    this.currentUser = currAcc;
    console.log(currAcc, currBtn);

    if (currAcc.status === "admin") {
      await this.initAdminView(currAcc);
    } else if (currAcc.status === "std") {
      await this.initStandardView();
    }
  }

  async initAdminView(currAcc) {
    // Get sectors from Supabase
    console.log("Loading sectors for user:", currAcc);
    const result = await sectorService.listSectors();
    if (!result.success) {
      console.error("Failed to load sectors:", result.error);
      this.showNotification(`Errore nel caricamento: ${result.error}`, "error");
      return;
    }

    console.log("Loaded sectors:", result.data);
    // Setup the data table
    await this.setupDataTable(result.data, true);
  }

  async initStandardView() {
    const result = await sectorService.listSectors();
    if (!result.success) {
      console.error("Failed to load sectors:", result.error);
      return;
    }

    // Setup the data table (read-only)
    await this.setupDataTable(result.data, false);
  }

  async setupDataTable(data, isAdmin = false) {
    console.log("Setting up sector data table with data:", data);

    // Fetch companies and crops for name lookups
    const [companiesResult, cropsResult] = await Promise.all([
      companyService.listCompanies(),
      cropService.listCrops(),
    ]);

    const companies = companiesResult.success ? companiesResult.data : [];
    const crops = cropsResult.success ? cropsResult.data : [];

    // Create lookup maps for company and crop names
    const companyMap = companies.reduce((map, company) => {
      map[company.id] = company.company_name;
      return map;
    }, {});

    const cropMap = crops.reduce((map, crop) => {
      map[crop.cropId] = crop.crop;
      return map;
    }, {});

    // Enrich data with company and crop names
    const enrichedData = data.map((sector) => ({
      ...sector,
      company_name: companyMap[sector.company_id] || "N/A",
      crop_name: cropMap[sector.crop_id] || "N/A",
    }));

    // Clear existing table and add Bootstrap container
    this.sectorTableWindow.innerHTML = `
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-12">
            <div class="card border-0">
              <div class="card-header" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); border: none; padding: 1.5rem;">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <div class="bg-white rounded-circle p-2 me-3" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                      <img src="/icons/menu-sector.jpg" alt="Sector Icon" style="width: 35px; height: 35px; border-radius: 15px; object-fit: cover;">
                    </div>
                    <div>
                      <h5 class="card-title mb-0 text-white fw-bold">Gestione Settori</h5>
                      <small class="text-white opacity-75"></small>
                    </div>
                  </div>
                  ${
                    isAdmin
                      ? `
                    <button class="btn btn-light add-sector-btn shadow-sm" style="padding: 0.75rem 1.5rem; border-radius: 10px; font-weight: 500;">
                      <i class="bi bi-plus-circle me-2" style="color: #59a370;"></i>
                      <span style="color: #59a370;">Aggiungi Settore</span>
                    </button>
                  `
                      : ""
                  }
                </div>
              </div>
              <div class="card-body p-0" style="border-radius: 0 0 15px 15px; overflow: hidden;">
                <div id="sectors-table" style="width: 100%; min-height: 400px;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Add event listener for the new add button
    if (isAdmin) {
      const addBtn = this.sectorTableWindow.querySelector(".add-sector-btn");
      if (addBtn) {
        addBtn.addEventListener("click", () => this.handleAddSector());
      }
    }

    // Add custom styles first
    this.addCustomStyles();

    // Define columns based on user role
    const columns = [
      // {
      //   title: "ID",
      //   field: "sector_id",
      //   sorter: "string",
      //   width: 120,
      //   headerFilter: "input",
      // },
      {
        title: "Settore",
        field: "sector_name",
        sorter: "string",
        width: 180,
        headerFilter: "input",
      },
      {
        title: "Azienda",
        field: "company_name",
        sorter: "string",
        width: 160,
        headerFilter: "input",
      },
      {
        title: "Coltura",
        field: "crop_name",
        sorter: "string",
        width: 140,
        headerFilter: "input",
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span>Lungh.</span><span>(m)</span></div>',
        field: "length_m",
        sorter: false,
        headerSort: false,
        width: 105,
        formatter: (cell) => `${parseFloat(cell.getValue() || 0).toFixed(1)} m`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span>Largh.</span><span>(m)</span></div>',
        field: "width_m",
        sorter: false,
        headerSort: false,
        width: 105,
        formatter: (cell) => `${parseFloat(cell.getValue() || 0).toFixed(1)} m`,
      },
      {
        /*title:
          '<div class="d-flex flex-column align-items-center"><span>Area</span><span>(m²)</span></div>',
        field: "area_mq",
        sorter: false,
        headerSort: false,
        width: 100,
        formatter: (cell) =>
          `${parseFloat(cell.getValue() || 0).toFixed(0)} m²`,
      },
      {*/
        title:
          '<div class="d-flex flex-column align-items-center"><span>Dist.File</span><span>Erog. (m)</span></div>',
        //field: "emitter_distance_m",
        field: "distance_supply_row",
        sorter: false,
        headerSort: false,
        width: 105,
        formatter: (cell) => `${parseFloat(cell.getValue() || 0).toFixed(1)} m`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span>Dist.</span><span>Erog. (cm)</span></div>',
        //field: "emitter_spacing_cm",
        field: "distance_suppliers_cm",
        sorter: false,
        headerSort: false,
        width: 110,
        formatter: (cell) =>
          `${parseFloat(cell.getValue() || 0).toFixed(1)} cm`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span>Port. Nom.</span><span>(L/h)</span></div>',
        field: "nominal_flow_rate_lh",
        sorter: false,
        headerSort: false,
        width: 110,
        formatter: (cell) =>
          `${parseFloat(cell.getValue() || 0).toFixed(1)} L/h`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span>Port. Fert.</span><span>(L/h)</span></div>',
        field: "ferti_flow_rate_lh",
        sorter: false,
        headerSort: false,
        width: 110,
        formatter: (cell) =>
          `${parseFloat(cell.getValue() || 0).toFixed(1)} L/h`,
      },
      {
        title:
          '<div class="d-flex flex-column align-items-center"><span>Lungh.Tubi</span><span>Coll. (m)</span></div>',
        //field: "collector_pipe_length_m",
        field: "pipe_length_m",
        sorter: false,
        headerSort: false,
        width: 112,
        formatter: (cell) => `${parseFloat(cell.getValue() || 0).toFixed(1)} m`,
      },
    ];

    // Add action buttons for admin users
    if (isAdmin) {
      columns.push({
        title: "Azioni",
        field: "actions",
        sorter: false,
        headerSort: false,
        width: 120,
        formatter: () => {
          return `
            <div class="btn-group" role="group">
              <button class="btn btn-outline-primary btn-sm btn-edit" title="Modifica">
                <i class="bi bi-pencil" style="pointer-events: none;"></i>
              </button>
              <button class="btn btn-outline-danger btn-sm btn-delete" title="Elimina">
                <i class="bi bi-trash" style="pointer-events: none;"></i>
              </button>
            </div>
          `;
        },
        cellClick: (e, cell) => {
          e.stopPropagation();
          const target = e.target.closest("button");
          if (!target) return;

          const rowData = cell.getRow().getData();

          if (target.classList.contains("btn-edit")) {
            this.handleUpdateSector(rowData);
          } else if (target.classList.contains("btn-delete")) {
            this.handleDeleteSector(rowData);
          }
        },
      });
    }

    console.log("Creating Tabulator with columns:", columns);

    // Wait a bit to ensure DOM is ready
    setTimeout(() => {
      try {
        // Initialize Tabulator
        this.table = new Tabulator("#sectors-table", {
          data: enrichedData,
          columns: columns,
          layout: "fitColumns",
          responsiveLayout: "hide",
          pagination: "local",
          paginationSize: 15,
          paginationSizeSelector: [10, 15, 25, 50],
          movableColumns: true,
          resizableRows: true,
          tooltips: true,
          tooltipsHeader: true,
          initialSort: [{ column: "sector_id", dir: "asc" }],
          placeholder: "Nessun settore trovato",
          langs: {
            it: {
              pagination: {
                page_size: "Righe per pagina",
                page_title: "Mostra pagina",
                first: "Prima",
                first_title: "Prima pagina",
                last: "Ultima",
                last_title: "Ultima pagina",
                prev: "Precedente",
                prev_title: "Pagina precedente",
                next: "Successiva",
                next_title: "Pagina successiva",
                all: "Tutte",
                counter: {
                  showing: "Mostrando",
                  of: "di",
                  rows: "righe",
                },
              },
              headerFilters: {
                default: "Filtra colonna...",
                columns: {
                  sector_id: "Filtra per ID...",
                  sector_name: "Filtra per settore...",
                  company_name: "Filtra per azienda...",
                  crop_name: "Filtra per coltura...",
                },
              },
            },
          },
          locale: "it",
          columnDefaults: {
            tooltip: true,
          },
        });

        console.log("Tabulator created successfully:", this.table);
      } catch (error) {
        console.error("Error creating Tabulator:", error);
        // Fallback to simple table
        this.createFallbackTable(enrichedData, columns);
      }
    }, 100);
  }

  createFallbackTable(data, columns) {
    console.log("Creating fallback table");

    let tableHTML = `
      <div style="border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; background: white;">
        <table style="width: 100%; border-collapse: collapse;">
          <thead style="background-color: #f8fafc;">
            <tr>
    `;

    columns.forEach((col) => {
      tableHTML += `<th style="padding: 12px 8px; text-align: left; font-weight: 600; border-bottom: 2px solid #e5e7eb;">${col.title}</th>`;
    });

    tableHTML += `
            </tr>
          </thead>
          <tbody>
    `;

    data.forEach((row, index) => {
      const bgColor = index % 2 === 0 ? "#ffffff" : "#f9fafb";
      tableHTML += `<tr style="background-color: ${bgColor};">`;

      columns.forEach((col) => {
        if (col.field === "actions") {
          tableHTML += `
            <td style="padding: 8px; border-bottom: 1px solid #f3f4f6; text-align: center;">
              <button onclick="window.sectorController.handleUpdateSector(${JSON.stringify(
                row
              ).replace(/"/g, "&quot;")})" 
                      style="background: none; border: none; color: #3b82f6; cursor: pointer; margin-right: 8px;">
                ✏️
              </button>
              <button onclick="window.sectorController.handleDeleteSector(${JSON.stringify(
                row
              ).replace(/"/g, "&quot;")})" 
                      style="background: none; border: none; color: #ef4444; cursor: pointer;">
                🗑️
              </button>
            </td>
          `;
        } else {
          let value = row[col.field] || "";
          if (
            col.formatter &&
            (col.field.includes("_m") ||
              col.field.includes("rate") ||
              col.field === "area_mq")
          ) {
            if (col.field === "area_mq") {
              value = `${parseFloat(value || 0).toFixed(0)} m²`;
            } else if (col.field.includes("rate")) {
              value = `${parseFloat(value || 0).toFixed(1)} L/h`;
            } else {
              value = `${parseFloat(value || 0).toFixed(1)} m`;
            }
          }
          tableHTML += `<td style="padding: 8px; border-bottom: 1px solid #f3f4f6;">${value}</td>`;
        }
      });

      tableHTML += `</tr>`;
    });

    tableHTML += `
          </tbody>
        </table>
      </div>
    `;

    this.sectorTableWindow.innerHTML = tableHTML;

    // Make controller available globally for fallback buttons
    window.sectorController = this;
  }

  addCustomStyles() {
    if (document.getElementById("sector-table-styles")) return;

    const style = document.createElement("style");
    style.id = "sector-table-styles";
    style.textContent = `
      /* Tabulator base styling for sectors */
      .tabulator {
        border: none !important;
        border-radius: 0 !important;
        font-family: 'Poppins', sans-serif !important;
        font-size: 14px !important;
        background-color: white !important;
        overflow: hidden !important;
      }
      
      /* Header styling */
      .tabulator .tabulator-header {
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
        border-bottom: 2px solid #59a370 !important;
      }
      
      .tabulator .tabulator-header .tabulator-col {
        background: transparent !important;
        border-right: 1px solid #e5e7eb !important;
        padding: 15px 12px !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-col-content {
        padding: 0 !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-col-title {
        font-weight: 600 !important;
        color: #59a370 !important;
        font-size: 13px !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
      }
      
      .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover {
        background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%) !important;
      }
      
      .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover .tabulator-col-title {
        color: white !important;
      }
      
      /* Row styling */
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row {
        border-bottom: 1px solid #f1f5f9 !important;
        min-height: 50px !important;
        transition: all 0.2s ease !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row:hover {
        background: linear-gradient(135deg, #f0f9f4 0%, #ecfdf5 100%) !important;
        box-shadow: 0 2px 4px rgba(89, 163, 112, 0.1) !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-row-even {
        background-color: #ffffff !important;
      }
      
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-row-odd {
        background-color: #fafbfc !important;
      }
      
      /* Cell styling */
      .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell {
        border-right: 1px solid #f3f4f6 !important;
        padding: 12px !important;
        vertical-align: middle !important;
        font-weight: 500 !important;
      }
      
      /* Filter styling */
      .tabulator .tabulator-header .tabulator-col .tabulator-header-filter input {
        border: 2px solid #e5e7eb !important;
        border-radius: 8px !important;
        padding: 6px 12px !important;
        font-size: 12px !important;
        width: 100% !important;
        box-sizing: border-box !important;
        transition: all 0.3s ease !important;
        font-family: 'Poppins', sans-serif !important;
      }
      
      .tabulator .tabulator-header .tabulator-col .tabulator-header-filter input:focus {
        outline: none !important;
        border-color: #59a370 !important;
        box-shadow: 0 0 0 3px rgba(89, 163, 112, 0.1) !important;
        background-color: #f8fafc !important;
      }
      
      /* Pagination styling */
      .tabulator .tabulator-footer {
        border-top: 2px solid #e5e7eb !important;
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
        padding: 15px 20px !important;
        border-radius: 0 0 15px 15px !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page {
        background-color: white !important;
        border: 2px solid #e5e7eb !important;
        color: #59a370 !important;
        margin: 0 3px !important;
        padding: 8px 12px !important;
        border-radius: 8px !important;
        font-weight: 500 !important;
        transition: all 0.2s ease !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page.active {
        background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%) !important;
        color: white !important;
        border-color: #59a370 !important;
        box-shadow: 0 2px 4px rgba(89, 163, 112, 0.2) !important;
      }
      
      .tabulator .tabulator-footer .tabulator-page:hover:not(.active) {
        background-color: #f0f9f4 !important;
        border-color: #59a370 !important;
        transform: translateY(-1px) !important;
      }
      
      /* Bootstrap button group styling for actions */
      .btn-group .btn {
        margin: 0 !important;
        border-radius: 6px !important;
        transition: all 0.2s ease !important;
      }
      
      .btn-group .btn-outline-primary {
        border-color: #59a370 !important;
        color: #59a370 !important;
      }
      
      .btn-group .btn-outline-primary:hover {
        background-color: #59a370 !important;
        border-color: #59a370 !important;
        transform: translateY(-1px) !important;
      }
      
      .btn-group .btn-outline-danger:hover {
        transform: translateY(-1px) !important;
      }
      
      /* Responsive adjustments */
      @media (max-width: 768px) {
        .tabulator {
          font-size: 12px !important;
        }
        
        .tabulator .tabulator-tableHolder .tabulator-table .tabulator-row .tabulator-cell {
          padding: 8px 6px !important;
        }
        
        .btn-group .btn {
          padding: 4px 8px !important;
          font-size: 12px !important;
        }
        
        .tabulator .tabulator-header .tabulator-col {
          padding: 10px 8px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  async handleAddSector() {
    console.log("Adding new sector");

    // Add Bootstrap modal classes to the update window
    this.updateWindow.classList.remove("hidden");
    this.updateWindow.classList.add("modal", "fade", "show");
    this.updateWindow.style.display = "block";
    this.updateWindow.style.backgroundColor = "rgba(0,0,0,0.5)";

    // Update the modal content with Bootstrap structure
    const formMarkup = await this.createBootstrapFormMarkup();
    this.form.innerHTML = `
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body p-5">
            ${formMarkup}
          </div>
        </div>
      </div>
    `;

    // Add area calculation event listeners
    const lengthInput = this.form.querySelector("#length_m");
    const widthInput = this.form.querySelector("#width_m");
    const areaInput = this.form.querySelector("#area_ha");
    if (lengthInput && widthInput && areaInput) {
      const updateArea = () => {
        const length = parseFloat(lengthInput.value) || 0;
        const width = parseFloat(widthInput.value) || 0;
        const area = (length * width) / 10000;
        areaInput.value = length > 0 && width > 0 ? area.toFixed(4) : "";
      };
      lengthInput.addEventListener("input", updateArea);
      widthInput.addEventListener("input", updateArea);
    }

    // Handle form submission
    const uploadBtn = this.form.querySelector(".uploadSector__btn");
    const cancelBtn = this.form.querySelector('[data-bs-dismiss="modal"]');

    uploadBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      await this.submitNewSector();
    });

    cancelBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeModal();
    });
  }

  async handleUpdateSector(sectorData) {
    console.log("Updating sector:", sectorData);

    // Add Bootstrap modal classes to the update window
    this.updateWindow.classList.remove("hidden");
    this.updateWindow.classList.add("modal", "fade", "show");
    this.updateWindow.style.display = "block";
    this.updateWindow.style.backgroundColor = "rgba(0,0,0,0.5)";

    // Update the modal content with Bootstrap structure
    const formMarkup = await this.createBootstrapFormMarkup(true, sectorData);
    this.form.innerHTML = `
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body p-5">
            ${formMarkup}
          </div>
        </div>
      </div>
    `;

    // Add area calculation event listeners
    const lengthInputU = this.form.querySelector("#length_m");
    const widthInputU = this.form.querySelector("#width_m");
    const areaInputU = this.form.querySelector("#area_ha");
    if (lengthInputU && widthInputU && areaInputU) {
      const updateAreaU = () => {
        const length = parseFloat(lengthInputU.value) || 0;
        const width = parseFloat(widthInputU.value) || 0;
        const area = (length * width) / 10000;
        areaInputU.value = length > 0 && width > 0 ? area.toFixed(4) : "";
      };
      lengthInputU.addEventListener("input", updateAreaU);
      widthInputU.addEventListener("input", updateAreaU);
    }

    // Handle form submission
    const uploadBtn = this.form.querySelector(".uploadSector__btn");
    const cancelBtn = this.form.querySelector('[data-bs-dismiss="modal"]');

    uploadBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      await this.submitUpdateSector(sectorData.id);
    });

    cancelBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeModal();
    });
  }

  async handleDeleteSector(sectorData) {
    console.log("Deleting sector:", sectorData);

    // Create Bootstrap confirmation modal
    const confirmationHtml = `
      <div class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5);" id="deleteConfirmModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title">
                <i class="bi bi-exclamation-triangle me-2"></i>Conferma Eliminazione
              </h5>
            </div>
            <div class="modal-body">
              <p class="mb-3">Sei sicuro di voler eliminare il settore:</p>
              <div class="alert alert-warning">
                <strong><img src="/icons/menu-sector.jpg" alt="Sector Icon" style="width: 20px; height: 20px; border-radius: 10px; object-fit: cover; margin-right: 8px; vertical-align: middle;">${sectorData.sector_name}</strong>
              </div>
              <p class="text-muted small">Questa azione non può essere annullata.</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="cancelDelete">
                <i class="bi bi-x-circle me-1"></i>Annulla
              </button>
              <button type="button" class="btn btn-danger" id="confirmDelete">
                <i class="bi bi-trash me-1"></i>Elimina
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Add modal to body
    const modalContainer = document.createElement("div");
    modalContainer.innerHTML = confirmationHtml;
    document.body.appendChild(modalContainer);

    const modal = modalContainer.querySelector("#deleteConfirmModal");
    const confirmBtn = modal.querySelector("#confirmDelete");
    const cancelBtn = modal.querySelector("#cancelDelete");

    // Handle confirmation
    confirmBtn.addEventListener("click", async () => {
      const result = await sectorService.deleteSector(sectorData.id);
      if (result.success) {
        await this.refreshTable();
        this.showNotification("Settore eliminato con successo", "success");
      } else {
        console.error("Failed to delete sector:", result.error);
        const errorMessage =
          result.error || "Errore nell'eliminazione del settore";
        this.showNotification(errorMessage, "error");
      }
      document.body.removeChild(modalContainer);
    });

    // Handle cancellation
    cancelBtn.addEventListener("click", () => {
      document.body.removeChild(modalContainer);
    });
  }

  async submitNewSector() {
    const sectorData = this.getSectorDataFromForm();

    if (!this.validateSectorData(sectorData)) {
      this.showNotification(
        "Compila tutti i campi obbligatori con valori corretti",
        "error"
      );
      return;
    }

    // Check for duplicate sector name
    const checkResult = await sectorService.existsSectorByName(
      sectorData.sector_name
    );
    if (!checkResult.success) {
      this.showNotification("Errore nel controllo del nome settore.", "error");
      return;
    }
    if (checkResult.exists) {
      this.showNotification("Esiste già un settore con questo nome.", "error");
      return;
    }

    console.log("Creating sector:", sectorData);
    const result = await sectorService.createSector(sectorData);

    if (result.success) {
      this.closeModal();
      await this.refreshTable();
      this.showNotification("Settore creato con successo", "success");
    } else {
      console.error("Failed to create sector:", result.error);
      const errorMessage = result.error || "Errore nella creazione del settore";
      this.showNotification(errorMessage, "error");
    }
  }

  async submitUpdateSector(sectorId) {
    const sectorData = this.getSectorDataFromForm();

    if (!this.validateSectorData(sectorData)) {
      this.showNotification(
        "Compila tutti i campi obbligatori con valori corretti",
        "error"
      );
      return;
    }

    console.log("Updating sector:", sectorId, sectorData);
    const result = await sectorService.updateSector(sectorId, sectorData);

    if (result.success) {
      this.closeModal();
      await this.refreshTable();
      this.showNotification("Settore aggiornato con successo", "success");
    } else {
      console.error("Failed to update sector:", result.error);
      const errorMessage =
        result.error || "Errore nell'aggiornamento del settore";
      this.showNotification(errorMessage, "error");
    }
  }

  getSectorDataFromForm() {
    return {
      sector_name: this.form.querySelector('[name="sector_name"]').value.trim(),
      company_id: this.form.querySelector('[name="company_id"]').value.trim(),
      crop_id: this.form.querySelector('[name="crop_id"]').value.trim(),
      length_m: Number(this.form.querySelector('[name="length_m"]').value) || 0,
      width_m: Number(this.form.querySelector('[name="width_m"]').value) || 0,
      distance_supply_row:
        Number(this.form.querySelector('[name="distance_supply_row"]').value) ||
        0,
      distance_suppliers_cm:
        Number(
          this.form.querySelector('[name="distance_suppliers_cm"]').value
        ) || 0,
      nominal_flow_rate_lh:
        Number(
          this.form.querySelector('[name="nominal_flow_rate_lh"]').value
        ) || 0,
      ferti_flow_rate_lh:
        Number(this.form.querySelector('[name="ferti_flow_rate_lh"]').value) ||
        0,
      pipe_length_m:
        Number(this.form.querySelector('[name="pipe_length_m"]').value) || 0,
    };
  }

  validateSectorData(sectorData) {
    return (
      sectorData.sector_name &&
      sectorData.sector_name.length > 0 &&
      sectorData.company_id &&
      sectorData.crop_id &&
      sectorData.length_m > 0 &&
      sectorData.length_m > 0 &&
      sectorData.distance_supply_row > 0 &&
      sectorData.distance_suppliers_cm > 0 &&
      sectorData.nominal_flow_rate_lh > 0 &&
      sectorData.ferti_flow_rate_lh > 0 &&
      sectorData.pipe_length_m > 0
    );
  }

  closeModal() {
    this.updateWindow.classList.add("hidden");
    this.updateWindow.classList.remove("modal", "fade", "show");
    this.updateWindow.style.display = "none";
    this.updateWindow.style.backgroundColor = "";
    this.form.innerHTML = "";
  }

  async refreshTable() {
    if (!this.table) return;

    const [sectorsResult, companiesResult, cropsResult] = await Promise.all([
      sectorService.listSectors(),
      companyService.listCompanies(),
      cropService.listCrops(),
    ]);

    if (sectorsResult.success) {
      const companies = companiesResult.success ? companiesResult.data : [];
      const crops = cropsResult.success ? cropsResult.data : [];

      // Create lookup maps for company and crop names
      const companyMap = companies.reduce((map, company) => {
        map[company.id] = company.company_name;
        return map;
      }, {});

      const cropMap = crops.reduce((map, crop) => {
        map[crop.cropId] = crop.crop;
        return map;
      }, {});

      // Enrich data with company and crop names
      const enrichedData = sectorsResult.data.map((sector) => ({
        ...sector,
        company_name: companyMap[sector.company_id] || "N/A",
        crop_name: cropMap[sector.crop_id] || "N/A",
      }));

      this.table.setData(enrichedData);
    }
  }

  showNotification(message, type = "info") {
    // Create Bootstrap toast notification
    const toastId = `toast-${Date.now()}`;
    const iconClass =
      type === "success"
        ? "bi-check-circle-fill"
        : type === "error"
        ? "bi-exclamation-triangle-fill"
        : "bi-info-circle-fill";

    // Use our app's green theme colors
    const bgClass =
      type === "success"
        ? "text-white"
        : type === "error"
        ? "text-white"
        : "text-white";

    const bgStyle =
      type === "success"
        ? "background: linear-gradient(135deg, #059669 0%, #047857 100%);"
        : type === "error"
        ? "background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);"
        : "background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%);";

    const toastHtml = `
      <div class="toast align-items-center ${bgClass} border-0 shadow-lg" role="alert" aria-live="assertive" aria-atomic="true" id="${toastId}" style="${bgStyle} border-radius: 12px;">
        <div class="d-flex">
          <div class="toast-body py-3 px-4" style="font-weight: 500; font-size: 14px;">
            <i class="${iconClass} me-2" style="font-size: 16px;"></i>${message}
          </div>
          <button type="button" class="btn-close btn-close-white me-3 my-auto" data-bs-dismiss="toast" aria-label="Close" style="filter: brightness(0) invert(1);"></button>
        </div>
      </div>
    `;

    // Create or get toast container
    let toastContainer = document.querySelector(
      ".toast-container.fertify-notifications"
    );
    if (!toastContainer) {
      toastContainer = document.createElement("div");
      toastContainer.className =
        "toast-container fertify-notifications position-fixed top-0 end-0 p-3";
      toastContainer.style.zIndex = "9999";
      toastContainer.style.marginTop = "80px"; // Account for navbar height
      document.body.appendChild(toastContainer);
    }

    // Add toast to container
    const toastElement = document.createElement("div");
    toastElement.innerHTML = toastHtml;
    toastContainer.appendChild(toastElement.firstElementChild);

    // Initialize and show Bootstrap toast
    const toast = new bootstrap.Toast(document.getElementById(toastId), {
      autohide: true,
      delay: 5000,
    });

    toast.show();

    // Add custom animation styles
    const toastEl = document.getElementById(toastId);
    toastEl.style.transform = "translateX(100%)";
    toastEl.style.transition = "transform 0.3s ease-out";

    // Animate in
    setTimeout(() => {
      toastEl.style.transform = "translateX(0)";
    }, 10);

    // Remove toast element after it's hidden
    toastEl.addEventListener("hidden.bs.toast", () => {
      toastEl.style.transform = "translateX(100%)";
      setTimeout(() => {
        if (toastEl && toastEl.parentNode) {
          toastEl.remove();
        }
      }, 300);
    });
  }

  updateUI(currBtn) {
    // Clear active states and set current button as active
    document.querySelectorAll(".menu__btn").forEach((btn) => {
      btn.classList.remove("menu__btn--active");
    });
    currBtn.classList.add("menu__btn--active");

    hideMenu();
    // Clear all table windows
    clearAllTables(false);
  }

  // Create Bootstrap-styled form markup
  async createBootstrapFormMarkup(isEdit = false, sectorData = null) {
    const title = isEdit ? "Modifica Settore" : "Aggiungi Settore";
    const buttonText = isEdit ? "Aggiorna" : "Salva";

    // Fetch companies and crops for dropdowns
    const [companiesResult, cropsResult] = await Promise.all([
      companyService.listCompanies(),
      cropService.listCrops(),
    ]);

    const companies = companiesResult.success ? companiesResult.data : [];
    const crops = cropsResult.success ? cropsResult.data : [];

    // Create company options
    const companyOptions = companies
      .map(
        (company) =>
          `<option value="${company.id}" ${
            sectorData?.company_id === company.id ? "selected" : ""
          }>
        ${company.company_name}
      </option>`
      )
      .join("");

    // Create crop options
    const cropOptions = crops
      .map(
        (crop) =>
          `<option value="${crop.cropId}" ${
            sectorData?.crop_id === crop.cropId ? "selected" : ""
          }>
        ${crop.crop}
      </option>`
      )
      .join("");

    return `
      <div class="modal-header border-bottom-0 pb-3 mb-4" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); margin: -2rem -2rem 2rem -2rem; padding: 2rem; border-radius: 15px 15px 0 0;">
        <div class="d-flex align-items-center text-white">
          <div class="bg-white rounded-circle p-2 me-3" style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center;">
            <img src="/icons/menu-sector.jpg" alt="Sector Icon" style="width: 40px; height: 40px; border-radius: 20px; object-fit: cover;">
          </div>
          <div>
            <h4 class="modal-title mb-0 fw-bold">${title}</h4>
            <small class="opacity-75"></small>
          </div>
        </div>
      </div>
      
      <form class="needs-validation" novalidate>
        <div class="row g-4">
          <!-- Sector Name -->
          <div class="col-12 mb-3">
            <label for="sector_name" class="form-label fw-semibold fs-5" style="color: #59a370;">
              <i class="bi bi-tag me-2"></i>Nome Settore
            </label>
            <input 
              type="text" 
              class="form-control form-control-lg" 
              id="sector_name" 
              name="sector_name" 
              placeholder="Inserisci il nome del settore"
              value="${sectorData?.sector_name || ""}"
              style="border: 2px solid #e5e7eb; border-radius: 10px; padding: 1rem; font-size: 1.1rem;"
              required
            >
            <div class="invalid-feedback">
              Il nome del settore è obbligatorio.
            </div>
          </div>

          <!-- Reference Fields Section -->
          <div class="col-12">
            <div class="bg-light p-3 rounded-3 mb-3" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;">
              <h6 class="mb-0 fw-bold" style="color: #59a370;">
                <i class="bi bi-link-45deg me-2"></i>Riferimenti
              </h6>
              <small class="text-muted">Collegamento con azienda e coltura</small>
            </div>
          </div>

          <!-- Company and Crop Selectors -->
          <div class="col-lg-6">
            <label for="company_id" class="form-label fw-semibold">
              <img src="/icons/menu-company.jpg" alt="Company Icon" style="width: 20px; height: 20px; border-radius: 10px; object-fit: cover; margin-right: 8px; vertical-align: middle;">Azienda
            </label>
            <select 
              class="form-select form-select-lg" 
              id="company_id" 
              name="company_id" 
              style="border: 2px solid #e5e7eb; border-radius: 10px; padding: 0.75rem;"
              required
            >
              <option value="">Seleziona un'azienda...</option>
              ${companyOptions}
            </select>
            <div class="invalid-feedback">
              Seleziona un'azienda.
            </div>
          </div>

          <div class="col-lg-6">
            <label for="crop_id" class="form-label fw-semibold">
              <img src="/icons/menu-crop1.jpg" alt="Crop Icon" style="width: 20px; height: 20px; border-radius: 10px; object-fit: cover; margin-right: 8px; vertical-align: middle;">Coltura
            </label>
            <select 
              class="form-select form-select-lg" 
              id="crop_id" 
              name="crop_id" 
              style="border: 2px solid #e5e7eb; border-radius: 10px; padding: 0.75rem;"
              required
            >
              <option value="">Seleziona una coltura...</option>
              ${cropOptions}
            </select>
            <div class="invalid-feedback">
              Seleziona una coltura.
            </div>
          </div>

          <!-- Dimensions Section -->
          <div class="col-12">
            <div class="bg-light p-3 rounded-3 mb-3" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;">
              <h6 class="mb-0 fw-bold" style="color: #59a370;">
                <i class="bi bi-rulers me-2"></i>Dimensioni Campo
              </h6>
              <small class="text-muted">Lunghezza, larghezza e area del settore</small>
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="col-lg-4">
              <label for="length_m" class="form-label fw-semibold">
                <i class="bi bi-arrow-left-right me-1"></i>Lunghezza (m)
              </label>
              <div class="input-group input-group-lg">
                <input 
                  type="number" 
                  class="form-control" 
                  id="length_m" 
                  name="length_m" 
                  step="0.1" 
                  min="0"
                  placeholder="0.0"
                  value="${sectorData?.length_m || ""}"
                  style="border: 2px solid #e5e7eb; border-radius: 10px;"
                >
                <span class="input-group-text" style="background: #f8fafc; border: 2px solid #e5e7eb; color: #59a370; font-weight: 500;">m</span>
              </div>
            </div>
            <div class="col-lg-4">
              <label for="width_m" class="form-label fw-semibold">
                <i class="bi bi-arrow-up-down me-1"></i>Larghezza (m)
              </label>
              <div class="input-group input-group-lg">
                <input 
                  type="number" 
                  class="form-control" 
                  id="width_m" 
                  name="width_m" 
                  step="0.1" 
                  min="0"
                  placeholder="0.0"
                  value="${sectorData?.width_m || ""}"
                  style="border: 2px solid #e5e7eb; border-radius: 10px;"
                >
                <span class="input-group-text" style="background: #f8fafc; border: 2px solid #e5e7eb; color: #59a370; font-weight: 500;">m</span>
              </div>
            </div>
            <div class="col-lg-4">
              <label for="area_ha" class="form-label fw-semibold">
                <i class="bi bi-bounding-box me-1"></i>Area (ha)
              </label>
              <div class="input-group input-group-lg">
                <input 
                  type="number" 
                  class="form-control" 
                  id="area_ha" 
                  name="area_ha" 
                  step="0.0001" 
                  min="0"
                  placeholder="0.0000"
                  value="${
                    sectorData && sectorData.length_m && sectorData.width_m
                      ? (
                          (sectorData.length_m * sectorData.width_m) /
                          10000
                        ).toFixed(4)
                      : ""
                  }"
                  style="border: 2px solid #e5e7eb; border-radius: 10px; background: #f0f0f0;"
                  readonly
                >
                <span class="input-group-text" style="background: #f8fafc; border: 2px solid #e5e7eb; color: #59a370; font-weight: 500;">ha</span>
              </div>
            </div>
          </div>

          <!-- Technical Parameters Section -->
          <div class="col-12">
            <div class="bg-light p-3 rounded-3 mb-3" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;">
              <h6 class="mb-0 fw-bold" style="color: #59a370;">
                <i class="bi bi-gear me-2"></i>Parametri Tecnici
              </h6>
              <small class="text-muted">Configurazione dell'impianto di irrigazione</small>
            </div>
          </div>

          <!-- Distance Parameters -->
          <div class="col-lg-6">
            <label for="distance_supply_row" class="form-label fw-semibold">
              <i class="bi bi-distribute-horizontal me-1"></i>Distanza tra File di Erogazione (m)
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="distance_supply_row" 
                name="distance_supply_row" 
                step="0.01" 
                min="0"
                placeholder="0.00"
                value="${sectorData?.distance_supply_row || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
              >
              <span class="input-group-text" style="background: #f8fafc; border: 2px solid #e5e7eb; color: #59a370; font-weight: 500;">m</span>
            </div>
          </div>

          <div class="col-lg-6">
            <label for="distance_suppliers_cm" class="form-label fw-semibold">
              <i class="bi bi-distribute-vertical me-1"></i>Distanza tra Erogatori (cm)
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="distance_suppliers_cm" 
                name="distance_suppliers_cm" 
                step="1" 
                min="0"
                placeholder="0"
                value="${sectorData?.distance_suppliers_cm || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
              >
              <span class="input-group-text" style="background: #f8fafc; border: 2px solid #e5e7eb; color: #59a370; font-weight: 500;">cm</span>
            </div>
          </div>

          <!-- Flow Rates -->
          <div class="col-lg-4">
            <label for="nominal_flow_rate_lh" class="form-label fw-semibold">
              <i class="bi bi-speedometer2 me-1"></i>Portata Nominale dell'Erogatore (L/h)
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="nominal_flow_rate_lh" 
                name="nominal_flow_rate_lh" 
                step="0.1" 
                min="0"
                placeholder="0.0"
                value="${sectorData?.nominal_flow_rate_lh || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
              >
              <span class="input-group-text" style="background: #f8fafc; border: 2px solid #e5e7eb; color: #59a370; font-weight: 500;">L/h</span>
            </div>
          </div>

          <div class="col-lg-4">
            <label for="ferti_flow_rate_lh" class="form-label fw-semibold">
              <i class="bi bi-droplet me-1"></i>Portata Fertiniezione  (L/h)
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="ferti_flow_rate_lh" 
                name="ferti_flow_rate_lh" 
                step="0.1" 
                min="0"
                placeholder="0.0"
                value="${sectorData?.ferti_flow_rate_lh || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
              >
              <span class="input-group-text" style="background: #f8fafc; border: 2px solid #e5e7eb; color: #59a370; font-weight: 500;">L/h</span>
            </div>
          </div>

          <div class="col-lg-4">
            <label for="pipe_length_m" class="form-label fw-semibold">
              <i class="bi bi-diagram-3 me-1"></i>Lunghezza Tubi Collettori (m)
            </label>
            <div class="input-group input-group-lg">
              <input 
                type="number" 
                class="form-control" 
                id="pipe_length_m" 
                name="pipe_length_m" 
                step="0.1" 
                min="0"
                placeholder="0.0"
                value="${sectorData?.pipe_length_m || ""}"
                style="border: 2px solid #e5e7eb; border-radius: 10px;"
              >
              <span class="input-group-text" style="background: #f8fafc; border: 2px solid #e5e7eb; color: #59a370; font-weight: 500;">m</span>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="modal-footer border-top pt-4 mt-5 d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-outline-secondary btn-lg px-4" data-bs-dismiss="modal" style="border-radius: 10px;">
            <i class="bi bi-x-circle me-2"></i>Annulla
          </button>
          <button type="submit" class="btn btn-lg px-5 uploadSector__btn" style="background: linear-gradient(135deg, #59a370 0%, #4a8c62 100%); border: none; color: white; border-radius: 10px; font-weight: 500;">
            <i class="bi bi-check-circle me-2"></i>${buttonText}
          </button>
        </div>
      </form>
    `;
  }
}

// Create and export a singleton instance
export const sectorController = new SectorController();
